import createReducer from './_createReducerHelper';

export const MANIFEST = 'chartsManifest/MANIFEST';

const initialState = {};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [MANIFEST]: (state, { payload }) => payload,
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param manifest
 * @return {{type, payload: *}}
 */
export const setChartsManifest = (manifest) => ({
  type: MANIFEST,
  payload: manifest,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readChartsManifest = (state) => state.chartsManifest;
